/* Klara Clone — header tweaks
   Splits the desktop nav into two halves around the centered logo
   (Impulse-style), so the result matches the reference storefront. */
(function () {
  function splitHeaderNav() {
    var header = document.querySelector('.header--middle-center');
    if (!header) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var nav = header.querySelector('.header__inline-menu');
    if (!nav || nav.getAttribute('data-mb-split')) return;

    var ul = nav.querySelector('ul.list-menu--inline');
    if (!ul) return;

    var items = Array.prototype.slice.call(ul.children).filter(function (n) {
      return n.nodeType === 1;
    });
    if (items.length < 2) return;

    var mid = Math.ceil(items.length / 2);

    var rightNav = document.createElement('nav');
    rightNav.className = 'header__inline-menu header__inline-menu--right';
    var rightUl = ul.cloneNode(false);
    rightNav.appendChild(rightUl);

    // appendChild MOVES the node out of the left list into the right list
    for (var i = mid; i < items.length; i++) {
      rightUl.appendChild(items[i]);
    }

    var heading = header.querySelector('.header__heading');
    if (heading && heading.parentNode === header) {
      header.insertBefore(rightNav, heading.nextSibling);
    } else {
      header.appendChild(rightNav);
    }

    nav.setAttribute('data-mb-split', '1');
  }

  /* Reference puts the search icon FAR-LEFT and the cart FAR-RIGHT.
     Move the whole <details-modal class="header__search"> node (modal content
     travels with it, so it keeps working) to be a direct child of the header;
     CSS then pins it to the left. Desktop only. */
  function moveSearchLeft() {
    var header = document.querySelector('.header--middle-center');
    if (!header) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var search = header.querySelector('.header__search');
    if (!search || search.getAttribute('data-mb-moved')) return;
    if (search.parentNode === header) { search.setAttribute('data-mb-moved', '1'); return; }

    header.insertBefore(search, header.firstChild);
    search.setAttribute('data-mb-moved', '1');
  }

  function applyHeaderTweaks() {
    splitHeaderNav();
    moveSearchLeft();
  }

  if (document.readyState !== 'loading') {
    applyHeaderTweaks();
  } else {
    document.addEventListener('DOMContentLoaded', applyHeaderTweaks);
  }
  // Re-apply after Dawn rebuilds the sticky header / on editor section reload
  document.addEventListener('shopify:section:load', applyHeaderTweaks);
})();

/* Klara Clone — variant thumbs on product cards (Dulvera-style):
   hovering a thumb (or scrubbing across the photo) swaps the card image;
   clicking a thumb navigates to that variant. Delegated, so it works for
   every card on every page including AJAX-loaded recommendations. */
(function () {
  if (window.__mbCardThumbsInit) return;
  window.__mbCardThumbsInit = true;

  function mbSelectThumb(thumb) {
    var wrapper = thumb.closest('.card-wrapper') || thumb.closest('.card');
    if (!wrapper) return;
    var media = wrapper.querySelector('.card__media');
    if (!media) return;
    var newSrc = thumb.getAttribute('data-mb-thumb');
    if (newSrc) {
      /* Dawn cards stack TWO images (primary + secondary hover layer).
         Swap the src on EVERY image so whichever layer is visible
         reflects the selected variant. */
      var imgs = media.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) {
        if (imgs[k].src !== newSrc) {
          imgs[k].setAttribute('srcset', '');
          imgs[k].src = newSrc;
        }
      }
    }
    var sibs = wrapper.querySelectorAll('.mb-card__thumb');
    for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
    thumb.classList.add('is-active');
  }

  /* Preload a card's variant photos on first hover so swaps are instant. */
  function mbPreload(wrap) {
    if (!wrap || wrap.__mbPreloaded) return;
    wrap.__mbPreloaded = true;
    var ts = wrap.querySelectorAll('.mb-card__thumb');
    for (var i = 0; i < ts.length; i++) {
      var s = ts[i].getAttribute('data-mb-thumb');
      if (s) { var im = new Image(); im.src = s; }
    }
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    mbPreload(e.target.closest('.card-wrapper') || e.target.closest('.card'));
    var thumb = e.target.closest('.mb-card__thumb');
    if (thumb) mbSelectThumb(thumb);
  }, { passive: true });

  /* Thumbs are real <a href> links to their variant — only stop the click
     bubbling to the card-wide product link. */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.mb-card__thumb');
    if (!thumb) return;
    e.stopPropagation();
  });

  /* Scrub: moving the cursor across the photo cycles through the variants
     (photo split into N zones, one per thumb). */
  document.addEventListener('mousemove', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media) return;
    var wrapper = media.closest('.card-wrapper') || media.closest('.card');
    if (!wrapper) return;
    var thumbs = wrapper.querySelectorAll('.mb-card__thumb');
    if (thumbs.length < 2) return;
    var rect = media.getBoundingClientRect();
    var frac = (e.clientX - rect.left) / rect.width;
    if (frac < 0) frac = 0;
    if (frac > 0.999) frac = 0.999;
    var idx = Math.floor(frac * thumbs.length);
    var target = thumbs[idx];
    if (target && !target.classList.contains('is-active')) mbSelectThumb(target);
  }, { passive: true });

  /* Revert to the first variant photo when the cursor leaves the card. */
  document.addEventListener('mouseout', function (e) {
    var wrapper = e.target.closest && e.target.closest('.card-wrapper');
    if (!wrapper) return;
    if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
    var thumbs = wrapper.querySelectorAll('.mb-card__thumb');
    if (thumbs[0]) mbSelectThumb(thumbs[0]);
  }, { passive: true });
})();

/* 2026-10-14 (op het beste-dagen-thema opnieuw toegepast 22-10): PDP-hoverpreview (kleurvakje/miniatuur
   aanwijzen = foto wisselen) weggehaald. Bij scrollen gleden vakjes en miniaturen onder de muis door; elke
   "hover" klikte een miniatuur aan, wisselde de grote foto en trok de pagina terug naar de galerij. Klikken werkt gewoon. */

/* 28-10 (Remco): mobiele productgalerij met de foto in het midden en links/rechts een preview (zie mb-custom.css,
   "productfoto's op de productpagina"). Vult de previews van ::before (laatste foto) en ::after (eerste foto) en zet
   .mb-cur op de foto in het midden, zodat alleen die een vergrootglas toont. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function pick(img, want) {
    var set = (img.getAttribute('srcset') || '').split(',').map(function (s) {
      var p = s.trim().split(/\s+/);
      return { u: p[0], w: parseInt(p[1], 10) || 0 };
    }).filter(function (c) { return c.u; }).sort(function (a, b) { return a.w - b.w; });
    for (var i = 0; i < set.length; i++) if (set[i].w >= want) return set[i].u;
    return set.length ? set[set.length - 1].u : img.currentSrc || img.src;
  }
  function setup(list) {
    if (list.mbPeek) return;
    list.mbPeek = true;
    list.setAttribute('data-mb-peek', '');
    var raf = 0;
    function slides() {
      return Array.prototype.filter.call(list.children, function (el) {
        return el.classList.contains('product__media-item') && el.offsetWidth > 0;
      });
    }
    function vars(which, li, fw, fh, pw) {
      var img = li.querySelector('img');
      if (!img) return list.style.setProperty('--mb-peek-' + which, 'none');
      var nw = img.naturalWidth || +img.getAttribute('width') || 1, nh = img.naturalHeight || +img.getAttribute('height') || 1;
      var s = Math.min(fw / nw, fh / nh), w = nw * s, h = nh * s, x = (fw - w) / 2, y = (fh - h) / 2;
      var px = which === 'prev' ? x - (fw - pw) : x;
      list.style.setProperty('--mb-peek-' + which, 'url("' + pick(img, Math.round(w * 2)) + '")');
      list.style.setProperty('--mb-peek-' + which + '-size', w + 'px ' + h + 'px');
      list.style.setProperty('--mb-peek-' + which + '-pos', px + 'px ' + y + 'px');
    }
    function mark() {
      raf = 0;
      var ss = slides(); if (!ss.length) return;
      var lr = list.getBoundingClientRect(), c = lr.left + lr.width / 2, best = ss[0], bd = 1e9;
      ss.forEach(function (sl) {
        var r = sl.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - c);
        if (d < bd) { bd = d; best = sl; }
      });
      ss.forEach(function (sl) { sl.classList.toggle('mb-cur', sl === best); });
    }
    function layout() {
      if (!mq.matches) return;
      var ss = slides(); if (!ss.length) return;
      var fr = ss[0].querySelector('.product-media-container') || ss[0];
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      var fw = ss[0].offsetWidth, pw = Math.max(0, (list.clientWidth - fw) / 2 - gap);
      list.style.setProperty('--mb-peek-w', pw + 'px');
      if (ss.length > 1) {
        vars('prev', ss[ss.length - 1], fw, fr.offsetHeight, pw);
        vars('next', ss[0], fw, fr.offsetHeight, pw);
      }
      mark();
    }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(mark); }, { passive: true });
    new MutationObserver(function () { requestAnimationFrame(layout); }).observe(list, { childList: true });
    list.addEventListener('load', function () { layout(); }, true);
    window.addEventListener('resize', layout);
    if (mq.addEventListener) mq.addEventListener('change', layout);
    layout();
  }
  function scan() {
    document.querySelectorAll('.product__media-list.grid--peek').forEach(setup);
  }
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();

/* 28-10 (Remco): "dat ik ook naar links kan scrollen en dat die < 1/10 > selecter gewoon grijze bolletjes worden".
   Mobiel: de productgalerij loopt rond. Voor foto 1 staat een kopie van de laatste foto en na de laatste foto een kopie
   van foto 1 (li.mb-loop, zonder id en data-media-id, dus de slider, de variantvolgorde en de serverupdate tellen ze niet
   mee). Komt de galerij tot stilstand op een kopie, dan springt hij onzichtbaar naar de echte foto. list.mbLoopHome()
   geeft de scrollpositie waarop foto 1 in het midden staat (media-gallery.js gebruikt die i.p.v. 0).
   De teller met pijltjes is vervangen door grijze bolletjes (tikken = naar die foto). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function real(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      return el.matches('li[data-media-id]') && !el.classList.contains('mb-loop');
    });
  }
  function mid(el) { var r = el.getBoundingClientRect(); return r.left + r.width / 2; }
  function copy(src) {
    var c = src.cloneNode(true);
    c.classList.add('mb-loop');
    c.classList.remove('is-active', 'mb-cur');
    ['id', 'data-media-id', 'data-mb-pos'].forEach(function (a) { c.removeAttribute(a); });
    c.setAttribute('aria-hidden', 'true');
    c.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
    c.querySelectorAll('a, button, input, [tabindex]').forEach(function (e) { e.setAttribute('tabindex', '-1'); });
    var si = src.querySelector('img'), ci = c.querySelector('img');
    if (ci) ci.setAttribute('loading', 'eager');
    if (si && ci && si.currentSrc) ci.src = si.currentSrc;
    c.mbSrc = src;
    return c;
  }
  function setup(list) {
    if (list.mbLoop) return;
    list.mbLoop = true;
    var host = list.parentElement, settleT = 0, touching = false, raf = 0;
    var dots = document.createElement('div');
    dots.className = 'mb-dots';
    dots.setAttribute('aria-hidden', 'true');
    host.appendChild(dots);
    function jump(dx) {
      if (!dx) return;
      var snap = list.style.scrollSnapType;
      list.style.scrollSnapType = 'none';
      list.scrollLeft += dx;
      requestAnimationFrame(function () { list.style.scrollSnapType = snap; });
    }
    function nearest() {
      var c = mid(list), best = null, bd = 1e9;
      Array.prototype.forEach.call(list.children, function (el) {
        if (!el.offsetWidth) return;
        var d = Math.abs(mid(el) - c);
        if (d < bd) { bd = d; best = el; }
      });
      return best;
    }
    function current() { var n = nearest(); return n && n.classList.contains('mb-loop') ? n.mbSrc : n; }
    function clones() { return Array.prototype.filter.call(list.children, function (el) { return el.classList.contains('mb-loop'); }); }
    function sync() {
      var rs = real(list), want = mq.matches && rs.length > 1, cs = clones();
      var first = list.firstElementChild, last = list.lastElementChild;
      var ok = want ? cs.length === 2 && first === cs[0] && last === cs[1] && first.mbSrc === rs[rs.length - 1] && last.mbSrc === rs[0] : cs.length === 0;
      if (!ok) {
        var cur = current(), before = cur && cur.isConnected ? mid(cur) : null;
        cs.forEach(function (c) { c.remove(); });
        if (want) {
          list.insertBefore(copy(rs[rs.length - 1]), list.firstElementChild);
          list.appendChild(copy(rs[0]));
          list.setAttribute('data-mb-loop', '');
        } else list.removeAttribute('data-mb-loop');
        if (before !== null && cur.isConnected) jump(mid(cur) - before);
      }
      paint();
    }
    function paint() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var rs = real(list);
        if (dots.childElementCount !== rs.length) {
          dots.textContent = '';
          rs.forEach(function () { var d = document.createElement('span'); d.className = 'mb-dot'; dots.appendChild(d); });
        }
        dots.hidden = rs.length < 2;
        var i = rs.indexOf(current());
        Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }
    function settle() {
      if (touching || !list.hasAttribute('data-mb-loop')) return paint();
      var n = nearest();
      if (n && n.classList.contains('mb-loop') && n.mbSrc && n.mbSrc.isConnected) jump(mid(n.mbSrc) - mid(n));
      paint();
    }
    list.mbLoopHome = function () {
      var rs = real(list);
      if (!list.hasAttribute('data-mb-loop') || !rs.length) return 0;
      return Math.max(0, Math.round(list.scrollLeft + mid(rs[0]) - mid(list)));
    };
    list.addEventListener('scroll', function () { clearTimeout(settleT); settleT = setTimeout(settle, 130); paint(); }, { passive: true });
    if ('onscrollend' in window) list.addEventListener('scrollend', function () { clearTimeout(settleT); settle(); });
    list.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (ev) {
      list.addEventListener(ev, function () { touching = false; clearTimeout(settleT); settleT = setTimeout(settle, 160); }, { passive: true });
    });
    dots.addEventListener('click', function (e) {
      var k = Array.prototype.indexOf.call(dots.children, e.target), rs = real(list);
      if (k > -1 && rs[k]) jump(Math.round(mid(rs[k]) - mid(list)));
    });
    new MutationObserver(sync).observe(list, { childList: true });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    list.addEventListener('load', function () { paint(); }, true);
    sync();
  }
  function scan() { document.querySelectorAll('.product__media-list.grid--peek.slider--mobile').forEach(setup); }
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
